<p class="text">
  <slot />
</p>

<style lang="scss">
  .text {
    font-weight: 500;
    font-size: clamp(5px, 1vw, 16px);
    line-height: 160%;

    padding-top: 30px;
    padding-bottom: 20px;
  }

  @include mobile {
    .text {
      font-size: 4.7vw;
    }
  }
</style>
